<template>
    <div>
        <h1 style="color:red">{{score}}</h1>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    let _ = require('lodash');

    export default {
        name: "Score",

        props: ['question'],

        computed: {
            ...mapState([

            ]),
            ...mapState('quiz',
                [
                    'score'
                ]
            ),
        },

        created() {

        },

        data() {
            return {

            }
        },
    }
</script>

<style scoped>

</style>